// import {
//   AppBar,
//   Button,
//   Grid,
//   Menu,
//   MenuItem,
//   Snackbar,
//   Toolbar,
//   Typography
// } from "@material-ui/core";
// import {
//   Card,
//   CardBody,
//   Row,
//   Col
// } from "reactstrap";
// import AccountCircleIcon from "@mui/icons-material/AccountCircle";
// import {
//   ArrowDropDown,
//   LockRounded,
//   SettingsBrightness,
//   WbSunnyTwoTone,
// } from "@material-ui/icons";
// import StocksLogo from "../../../Assets/logo.png";

// import Modal from "react-awesome-modal";
// import axios from "axios";
// import React, { Component } from "react";
// import Constants from "../../Variables/Constants";
// import profile from "../../../Assets/profile.jpg";
// import init from "../../../helpers/WindowToken";
// export default class MainAppbar extends Component {
//   state = {
//     theme: localStorage.getItem("theme"),
//     showMenu: false,
//     anchorEl: null,
//     profileData: {},
//     notifyStatus: false,
//     notifyDelete: false,
//     visible: false,
//     delLoading: false,
//     visibleProfile: false,
//     name: "",
//     email: "",
//     mobile_no: "",
//     cpu: "",
//     memory: "",
//   };

//   componentDidMount() {
//     this.getProfile();
//   }
//   getProfile = () => {
//     try {
//       axios.get(Constants.getUrls.getProfile).then((res) => {
//         console.log(res);
//         if (res.data.status === "success") {
//           this.setState({
//             profileData: res.data.data,
//           });
//         }
//       });
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   submit = (e) => {
//     this.setState({
//       loading: true,
//     });
//     e.preventDefault();

//     if (init() === "success") {
//       let submitLoad = {
//         oldPassword: this.state.current_password,
//         newPassword: this.state.new_password,
//       };
//       console.log(submitLoad);
//       axios
//         .post(Constants.postUrls.changePassword, submitLoad)
//         .then((resp) => {
//           console.log(resp);
//           setTimeout(() => {
//             this.setState({
//               notification: true,
//               loading: true,
//               message: resp.data.Message,
//             });
//           }, 2000);
//           setTimeout(() => {
//             this.setState({
//               loading: false,
//               redirect: true,
//             });
//           }, 4000);
//         })
//         .catch((err) => {
//           if (err) {
//             console.log(err);
//             this.setState({
//               loading: false,
//               message: "Old Password Does Not Match",
//               error: true,
//             });
//             setTimeout(() => {
//               this.setState({
//                 error: false,
//               });
//             }, 3000);
//           }
//         });
//     }
//   };

//   handleInput = (e) => {
//     this.setState({
//       [e.target.name]: e.target.value,
//     });
//   };

//   handleModal = () => {
//     this.setState({
//       visible: true,
//     });
//   };

//   handleProfileModal = () => {
//     this.setState({
//       visibleProfile: true,
//     });
//   };

//   handleClick = (event) => {
//     this.setState({ showMenu: true, anchorEl: event.currentTarget });
//   };
//   handleClose = (event) => {
//     this.setState({ showMenu: false, anchorEl: null });
//   };
//   applyTheme = () => {
//     const theme = localStorage.getItem("theme");
//     localStorage.setItem("theme", theme === "dark" ? "light" : "dark");
//     window.location.reload();
//   };
//   logout = () => {
//     localStorage.removeItem("accessToken");
//     window.location.href = "/login";
//   };
//   render() {
//     const state = this.state;
//     return (
//       <>
//         <AppBar
//           className="appbar"
//           position="fixed"
//           color="default"
//           style={{ height: "80px" }}
//         >
//           <Toolbar style={{ height: "56px" }}>
//             <Grid container>
//               <Grid item xs={4}>
//                 <div
//                   style={{
//                     display: "flex",
//                     width: "20rem",
//                     alignItems: "center",
//                   }}
//                 >
//                   {
//                     <a href="/dashboard">
//                       <img
//                         style={{
//                           width: "80px",
//                           height: "70px",
//                           marginRight: "2rem",
//                           marginTop: "10px"
//                         }}
//                         src={StocksLogo}
//                       />
//                     </a>
//                   }
//                 </div>
//               </Grid>

//               {/* NOTIFICATION */}
//               {this.state.notification ? (
//                 <Snackbar
//                   anchorOrigin={{ vertical: "top", horizontal: "right" }}
//                   open={true}
//                   color={"s"}
//                   autoHideDuration={6000}
//                   message={this.state.message}
//                 ></Snackbar>
//               ) : null}
//               {/* NOTIFICATION */}
//               <Grid item xs={8}>
//                 <Grid
//                   container
//                   alignItems="baseline"
//                 >
//                   <Grid
//                     container
//                     justify="flex-end"
//                     alignItems="baseline"
//                     style={{ marginTop: "5px" }}
//                   >
//                     <Grid
//                       container
//                       alignItems="baseline"
//                     >
//                       <Grid
//                         container
//                         justify="flex-end"
//                         alignItems="baseline"
//                         style={{ marginTop: "1.5rem", marginLeft: "-3rem" }}
//                       >
//                         <Button
//                           aria-controls="simple-menu"
//                           aria-haspopup="true"
//                           onClick={this.handleClick}
//                           endIcon={<ArrowDropDown />}
//                         >
//                           {this.state.profileData.name}
//                         </Button>
//                         <Menu
//                           anchorEl={this.state.anchorEl}
//                           id="simple-menu"
//                           keepMounted
//                           className="shadow-cc"
//                           open={this.state.showMenu}
//                           onClose={this.handleClose}
//                           style={{ borderRadius: "50px" }}
//                         >

//                           <MenuItem onClick={this.handleClose}>
//                             {" "}
//                             <Button
//                               onClick={this.applyTheme}
//                               style={{
//                                 display: "flex",
//                                 flexDirection: "row",
//                                 justifyContent: "space-between",
//                                 alignItems: "center",
//                                 gap: "10px",
//                                 width: "100%",
//                                 height: "100%",
//                               }}
//                             >
//                               {state.theme === "dark" ? (
//                                 <div
//                                   style={{
//                                     display: "flex",
//                                     justifyContent: "space-between",
//                                     alignItems: "center",
//                                     height: "100%",
//                                     gap: "10px",
//                                   }}
//                                 >
//                                   <Typography
//                                     children={
//                                       <p style={{ fontSize: 12 }}>Light Mode</p>
//                                     }
//                                   />
//                                   <WbSunnyTwoTone color="action" />
//                                 </div>
//                               ) : (
//                                 <div
//                                   style={{
//                                     display: "flex",
//                                     justifyContent: "space-between",
//                                     alignItems: "center",
//                                     height: "100%",
//                                     gap: "10px",
//                                   }}
//                                 >
//                                   <Typography
//                                     children={
//                                       <p style={{ fontSize: 12 }}>Dark Mode</p>
//                                     }
//                                   />
//                                   <div
//                                     className=""
//                                     style={{ marginBottom: "12px" }}
//                                   >
//                                     <SettingsBrightness color="action" />
//                                   </div>
//                                 </div>
//                               )}
//                             </Button>
//                           </MenuItem>
//                           <MenuItem onClick={this.handleClose}>
//                             <Button
//                               onClick={this.logout}
//                               style={{
//                                 display: "flex",
//                                 flexDirection: "row",
//                                 justifyContent: "space-between",
//                                 alignItems: "center",
//                                 gap: "10px",
//                                 width: "100%",
//                                 height: "100%",
//                               }}
//                             >
//                               <Typography
//                                 children={
//                                   <p style={{ fontSize: 12 }}>Logout</p>
//                                 }
//                               />
//                               <div
//                                 className=""
//                                 style={{ marginBottom: "12px" }}
//                               >
//                                 <LockRounded color="action" size={"small"} />
//                               </div>
//                             </Button>
//                           </MenuItem>
//                         </Menu>

//                         <div className="avatar">
//                           <AccountCircleIcon
//                             style={{ color: "#B77F2C", fontSize: "48px" }}
//                           />
//                         </div>
//                       </Grid>
//                     </Grid>
//                   </Grid>
//                 </Grid>
//               </Grid>
//             </Grid>
//           </Toolbar>
//         </AppBar>

//         <Modal
//           visible={this.state.visibleProfile}
//           width="450"
//           height="350"
//           effect="fadeInUp"
//           onClickAway={() => this.setState({ visibleProfile: false })}
//           style={{ position: "absolute" }}
//         >
//           <Row>
//             <Col xs={12} sm={12} md={12}>
//               <Card>
//                 <CardBody>
//                   <div style={{ padding: "10px" }}>
//                     <form className="loginFormWrapper">
//                       <img
//                         src={profile}
//                         alt="img"
//                         width="100px"
//                         height="100px"
//                         className="profileImg"
//                       />
//                       <div className="nameInput">
//                         {this.state.profileData.name}
//                       </div>
//                       <div className="otherInputs">
//                         {this.state.profileData.email}
//                       </div>
//                       <div className="otherInputs">
//                         {this.state.profileData.mobile_no}
//                       </div>
//                       <Button
//                         variant="contained"
//                         color="secondary"
//                         className="closeBtn"
//                         onClick={() => {
//                           this.setState({ visibleProfile: false });
//                         }}
//                       >
//                         Close
//                       </Button>
//                     </form>
//                   </div>
//                 </CardBody>
//               </Card>
//             </Col>
//           </Row>
//         </Modal>

//         <Modal
//           visible={this.state.visible}
//           width="600"
//           height="237"
//           effect="fadeInUp"
//           onClickAway={() => this.setState({ visible: false })}
//         >
//           <Row>
//             <Col xs={12} sm={12} md={12}>
//               <Card>
//                 <CardBody>
//                   <div className="modal" style={{ padding: "10px" }}>
//                     <form
//                       className="loginFormWrapperPass"
//                       onSubmit={this.submit}
//                     >
//                       <input
//                         type="password"
//                         placeholder="Current Password"
//                         name="current_password"
//                         required
//                         onChange={this.handleInput}
//                         className="currentPass"
//                       />

//                       <input
//                         type="password"
//                         placeholder="New Password"
//                         name="new_password"
//                         required
//                         onChange={this.handleInput}
//                         className="currentPass"
//                       />

//                       <Button
//                         color="primary"
//                         className="submitChangePass"
//                         variant="contained"
//                         type="submit"
//                       >
//                         {this.state.loading ? (
//                           "changing password "
//                         ) : this.state.error ? (
//                           <span style={{ color: "#BD0600" }}>
//                             Something Went Wrong !!!
//                           </span>
//                         ) : (
//                           " Submit"
//                         )}
//                       </Button>
//                       <Button
//                         variant="contained"
//                         color="secondary"
//                         className="cancelChangePass"
//                         onClick={() => {
//                           this.setState({ visible: false });
//                         }}
//                       >
//                         Cancel
//                       </Button>
//                     </form>
//                   </div>
//                 </CardBody>
//               </Card>
//             </Col>
//           </Row>
//         </Modal>
//       </>
//     );
//   }
// }
import React, { useState, useEffect } from "react";
import {
  AppBar,
  Avatar,
  Box,
  Button,
  Container,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Snackbar,
  Toolbar,
  Typography,
  useTheme,
  useMediaQuery,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import {
  ArrowDropDown,
  Brightness4,
  Brightness7,
  ExitToApp,
  Lock,
} from "@material-ui/icons";
import axios from "axios";
import Constants from "../../Variables/Constants";
import StocksLogo from "../../../Assets/logo.png";

const MainAppbar = ({ toggleTheme, themeMode }) => {
  // State management
  const [anchorEl, setAnchorEl] = useState(null);
  const [profileData, setProfileData] = useState({});
  const [notification, setNotification] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  // Fetch profile data on component mount
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await axios.get(Constants.getUrls.getProfile);
        if (response.data.status === "success") {
          setProfileData(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching profile:", error);
        showNotification("Failed to load profile", "error");
      }
    };

    fetchProfile();
  }, []);

  // Show notification
  const showNotification = (message, severity = "success") => {
    setNotification({
      open: true,
      message,
      severity,
    });
  };

  // Handle notification close
  const handleNotificationClose = (event, reason) => {
    if (reason === "clickaway") return;
    setNotification({ ...notification, open: false });
  };
  const logout = () => {
    localStorage.removeItem("accessToken");
    window.location.href = "/";
  };

  // Menu handlers
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  // Get user initials for avatar
  const getUserInitials = () => {
    if (profileData?.name) {
      return profileData.name
        .split(" ")
        .map((word) => word[0])
        .join("")
        .toUpperCase()
        .substring(0, 2);
    }
    return "U";
  };

  // Get avatar color based on theme
  const getAvatarColor = () => {
    return theme.palette.mode === "dark"
      ? theme.palette.primary.main
      : theme.palette.secondary.main;
  };

  return (
    <>
      <AppBar
        position="fixed"
        elevation={2}
        style={{
          backgroundColor:
            theme.palette.mode === "dark"
              ? "rgba(30, 30, 30, 0.95)"
              : "rgba(255, 255, 255, 0.95)",
          backdropFilter: "blur(10px)",
          borderBottom: `1px solid ${theme.palette.divider}`,
          height: isMobile ? "64px" : "80px",
          transition: "all 0.3s ease",
        }}
      >
        <Toolbar
          style={{
            minHeight: isMobile ? "64px" : "80px",
            padding: isMobile ? "0 16px" : "0 24px",
          }}
        >
          <Container maxWidth={false} style={{ padding: 0 }}>
            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              wrap="nowrap"
            >
              {/* Logo Section */}
              <Grid item style={{ flexShrink: 0 }}>
                <Box
                  display="flex"
                  alignItems="center"
                  style={{ cursor: "pointer" }}
                  onClick={() => (window.location.href = "/dashboard")}
                >
                  <img
                    src={StocksLogo}
                    alt="Stocks Logo"
                    style={{
                      width: isMobile ? "60px" : "80px",
                      height: isMobile ? "50px" : "70px",
                      objectFit: "contain",
                      marginRight: isMobile ? "12px" : "24px",
                      filter:
                        theme.palette.mode === "dark"
                          ? "brightness(1.2)"
                          : "none",
                      transition: "all 0.3s ease",
                    }}
                  />
                </Box>
              </Grid>

              {/* User Profile Section */}
              <Grid item style={{ flexShrink: 0 }}>
                <Box display="flex" alignItems="center" gap={isMobile ? 1 : 2}>
                  {!isMobile && (
                    <>
                      <Typography
                        variant="body1"
                        style={{
                          fontWeight: 500,
                          color: theme.palette.text.primary,
                          maxWidth: "200px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {profileData?.name || "User"}
                      </Typography>
                    </>
                  )}

                  {/* Avatar with Menu */}
                  <Box display="flex" alignItems="center">
                    <IconButton
                      onClick={handleMenuOpen}
                      size={isMobile ? "small" : "medium"}
                      style={{
                        padding: isMobile ? "4px" : "8px",
                        marginLeft: "8px",
                      }}
                    >
                      <Avatar
                        style={{
                          backgroundColor: getAvatarColor(),
                          color: theme.palette.getContrastText(
                            getAvatarColor()
                          ),
                          width: isMobile ? 32 : 40,
                          height: isMobile ? 32 : 40,
                          fontSize: isMobile ? "0.875rem" : "1rem",
                          fontWeight: 600,
                        }}
                      >
                        {getUserInitials()}
                      </Avatar>
                    </IconButton>

                    <Menu
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={handleMenuClose}
                      PaperProps={{
                        style: {
                          width: 220,
                          marginTop: isMobile ? 40 : 50,
                          backgroundColor: theme.palette.background.paper,
                          border: `1px solid ${theme.palette.divider}`,
                          borderRadius: 8,
                          boxShadow: theme.shadows[8],
                        },
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                    >
                      {/* Profile Menu Item */}
                      <MenuItem
                        onClick={handleMenuClose}
                        style={{
                          padding: "12px 16px",
                          display: "flex",
                          alignItems: "center",
                          gap: "12px",
                        }}
                      >
                        <Typography
                          variant="body2"
                          style={{
                            color: theme.palette.text.secondary,
                            fontWeight: 400,
                          }}
                        >
                          {profileData?.email ? `(${profileData.email})` : ""}
                        </Typography>
                      </MenuItem>

                      {/* Theme Toggle */}
                      <MenuItem
                        onClick={() => {
                          toggleTheme?.();
                          handleMenuClose();
                        }}
                        style={{
                          display: "flex",
                          gap: 12,
                        }}
                      >
                        {themeMode === "dark" ? (
                          <>
                            <Brightness7
                              fontSize="small"
                              style={{
                                color: theme.palette.warning.main,
                              }}
                            />
                            <Typography
                              variant="body2"
                              style={{ fontWeight: 500 }}
                            >
                              Light Mode
                            </Typography>
                          </>
                        ) : (
                          <>
                            <Brightness4
                              fontSize="small"
                              style={{
                                color: theme.palette.text.secondary,
                              }}
                            />
                            <Typography
                              variant="body2"
                              style={{ fontWeight: 500 }}
                            >
                              Dark Mode
                            </Typography>
                          </>
                        )}
                      </MenuItem>

                      {/* Logout */}
                      <MenuItem
                        onClick={() => {
                          logout();
                          handleMenuClose();
                        }}
                        style={{
                          padding: "12px 16px",
                          display: "flex",
                          alignItems: "center",
                          gap: "12px",
                          color: theme.palette.error.main,
                        }}
                      >
                        <ExitToApp fontSize="small" />
                        <Typography variant="body2" style={{ fontWeight: 600 }}>
                          Logout
                        </Typography>
                      </MenuItem>
                    </Menu>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Toolbar>
      </AppBar>

      {/* Notification Snackbar */}
      <Snackbar
        open={notification.open}
        autoHideDuration={6000}
        onClose={handleNotificationClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleNotificationClose}
          severity={notification.severity}
          variant="filled"
          style={{
            borderRadius: 8,
            boxShadow: theme.shadows[4],
          }}
        >
          {notification.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default MainAppbar;
